/**
 * Angular imports.
 */
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/**
 * Service imports.
 */
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../dataservices/jwt-decode.service';
import { GetService } from '../../dataservices/get.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
/**
 * SDK imports
 */
import { Analytics } from 'analytics2.0';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
import { NUMBERS } from 'src/app/constants/app.constants';
import { ENTRY, EXIT } from 'analytics2.0/dist/core/constants/analytic.interface';
import { ACTION_ON, ACTION_TYPE, CTA_TYPE, PRODUCT_TYPE_CONSTANT_NAME, SCREEN_NAME } from 'src/app/constants/app.constants';

/**
 * Connection Request List Component
 */
@Component({
  selector: 'app-connection-request-list',
  templateUrl: './connection-request-list.component.html',
  styleUrls: ['./connection-request-list.component.scss']
})
export class ConnectionRequestListComponent implements OnInit, OnDestroy {

  /**
   * Import numbers from constant.
   */
  public numbers = NUMBERS;

  @Input() limit;
  @Input() location;
  @Input() callingfrom;

  public screenName = SCREEN_NAME.CONNECTION_SUGGESTIONS
  public connectionRequestData = [];
  public Connoffset = 1;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public search_type: any = 'connection_request';
  public finished = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public total_connection_request: any;
  public offset = 1;
  public isInfoModalShown = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public info_msg: any;
  public suggestionData = [];
  public suggestionLength: number;
  public finishedsugg = false;
  public finishedsug = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public active_tab: any = '';
  public stillshow_banner = true;
  public totalConnection: number;
  public total_connections: number;
  public len = 1;
  public keyword = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public request_header: any;

  /**
   * Filter key for connection API.
   */
  public filter = {};

  /**
   * All conncetion filter.
   */
  public suggestionFilter = [];

  /**
   * start time
   */
  public startTime = new Date().getTime();

  /**
   * Selected filter Index.
   */
  public filterIndex = 0;

  /**
   * Save filter at once we hit api.
   */
  public runOnce = false;

  /**
   * Sugestion loader.
   */
  public connSuggLoader = false;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instances.
   */
  constructor(private getConnectionSer: GetService,
              private router: Router,
              public fcs: FunCollectionService,
              public multiLangService: MultiLangService,
              public masterService: MasterserviceService,
              public jwtSer: JwtDecodeService,
              public dss: DataStorageService,
              private analyticSdk: Analytics,
              public mls: NewLanguageService) {

    this.dss.connectionRouteChange.next('connection/request');

  }

  public canLoad = true;
  public pendingLoad = false;
  public busyGettingData = false;

  /**
   * ngOnInit
   */
  ngOnInit(): void {

    setInterval( () => {
      this.canLoad = true;
      if ( this.pendingLoad ) {
        this.onScrollDown();
      }
    }, 2000);
    if (this.callingfrom != 'grandround') {
      const entryData: ENTRY = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.CONNECTION,
        entity_code: 0,
        source: this.fcs.currentScreename ? this.fcs.currentScreename : localStorage.getItem('triggerSource'),
        current_screen_name: SCREEN_NAME.CONNECTION_SUGGESTIONS,
        start_time: this.startTime
      }
      this.fcs.currentScreename = SCREEN_NAME.CONNECTION_SUGGESTIONS;
      this.analyticSdk.analyticService.ENTRY(entryData);
    }

    this.subscriptions.add(this.dss.sent_counter.subscribe(data => {
      // tslint:disable-next-line: radix
      this.total_connections = parseInt(data);
    }));

    this.subscriptions.add(this.dss.connection_list_counter.subscribe(data => {
      // tslint:disable-next-line: radix
      this.totalConnection = parseInt(data);

    }));

    this.connectionsuggList();

    this.connectionRequestList();
  }

  public onScrollDown():void {
    if(this.busyGettingData){
      return;
    }
    this.busyGettingData = true;
    this.onScroll();
  }


  /**
   * call suggestion list Api
   */
  connectionRequestList(): void {
    this.finished = false;

    this.subscriptions.add(this.getConnectionSer.getconnectionList(this.search_type, this.Connoffset, 0, this.keyword, this.filter).subscribe(resData => {
      this.finished = true;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.Connoffset = data.data.offset;

          for (let i = 0; i < data.data.search_list.length; i++) {

            if (data.data.search_list[i].key == 'connection_request') {

              this.total_connection_request = data.data.search_list[i].total_connection_request;
              this.connectionRequestData = this.connectionRequestData.concat(data.data.search_list[i].list);
              this.len = this.total_connection_request;

              this.request_header = data.data.search_list[i];

            } else if (data.data.search_list[i].key != 'connection_request') {
              this.len = 0;
            }
          }
        } else if (data.status == 0) {
          this.fcs.errorHandeler(data);
        }
      });
    }));
  }

  /**
   * call suggestion list Api
   */
  connectionsuggList(): void {
    this.finishedsugg = false;


    this.subscriptions.add(this.getConnectionSer.getconnectionList(this.search_type, this.offset, 1, this.keyword, this.filter).subscribe(resData => {
      this.finishedsugg = true;
      this.busyGettingData = false;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == 1) {
          this.offset = data.data.offset;
          for (let i = 0; i < data.data.search_list.length; i++) {
            if (data.data.search_list[i].key == 'suggestion') {

              this.suggestionData = this.suggestionData.concat(data.data.search_list[i].list);

              this.suggestionLength = data.data.search_list[i].list.length;


            }
          }

          /**
           * Get connection filter.
           */
          if (this.runOnce === false) {
            this.runOnce = true;
            for (let i = 0; i < data.data.filter.length; i++) {
              if (data.data.filter[i].filter_data.length > 0) {
                for (let j = 0; j < data.data.filter[i].filter_data.length; j++) {
                  const customFilterData = {
                    'filterkey': data.data.filter[i].filter_key,
                    'id': data.data.filter[i].filter_data[j].id,
                    'value': data.data.filter[i].filter_data[j].value
                  };
                  this.suggestionFilter.push(customFilterData);
                }
              }
            }
            if (this.suggestionFilter.length > 0) {
              /**
               * Making object for 'ALL' filter.
               */
              this.suggestionFilter.unshift({ filterkey: 'all', id: 0, value: 'All' });
            }
          }


          if (this.offset == 2) {
            this.connectionsuggList();
          }

        } else if (data.status == 0) {

          this.fcs.errorHandeler(data);
        }

      });
    }));
  }

  /**
   * reset Info Modal
   */
  resetInfoModal(): void {
    this.isInfoModalShown = false;
  }

  /**
   * onScroll
   */
  onScroll(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    if (this.offset > 1) {
      this.finishedsug = false;
      this.connectionsuggList();
    }
  }

  /**
   * navigate to user
   */
  navigateTo(section): boolean {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');

      return false;

    }
    this.router.navigateByUrl(section);
    this.active_tab = section;
    this.masterService.connection_selected_tab.next(section);
  }

  /**
   * sent Request view more
   */
  sentRequestviewmore(): void {

    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    if (this.Connoffset > 1) {
      this.finished = false;
      this.connectionRequestList();
    }
  }

  /**
   * reset Suggestion List
   */
  resetSuggList(data): void {

    if (data.status == 9) {
      this.dss.sent_counter.next(++this.total_connections);

      if (this.total_connection_request == 0) {
        this.stillshow_banner = false;
      }
    } else if (data.status == 8) {
      this.dss.connection_list_counter.next(++this.totalConnection);
      this.total_connection_request--;

      if (this.total_connection_request == 0) {
        this.stillshow_banner = false;
      }

    } else {
      this.total_connection_request--;

      if (this.total_connection_request == 0) {
        this.stillshow_banner = false;
      }
    }

  }

  /**
   * remove con card
   */
  removeconcard(data): void {
    this.connectionRequestData.splice(data, 1);
    this.len = this.total_connection_request;
  }


  /**
   * Apply connection filter.
   */
  applySuggestionFilter(data: { filterkey: string; id: number; value: string; }): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.CONNECTION, 0,this.screenName, CTA_TYPE.CARD, ACTION_TYPE.CLICK, ACTION_ON.FILTER_CLICK, null, new Date().getTime(), [{key: 'FILTER', value: data.filterkey}]);
    this.connSuggLoader = true;
    this.suggestionData = [];
    this.offset = 1;
    if (this.masterService.isOnline === false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    this.finished = false;
    const filterKey = data.filterkey;
    if (filterKey === 'all') {
      this.filter = {};
      this.search_type = 'connection_request';
    } else {
      const filterObj = {
        [filterKey]: [data.id]
      };
      this.filter = JSON.stringify(filterObj);
      this.search_type = 'filter';
    }
    this.connectionsuggList();
  }


  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.callingfrom != 'grandround') {
      const exitData: EXIT = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.CONNECTION,
        entity_code: 0,
        current_screen_name: SCREEN_NAME.CONNECTION_SUGGESTIONS,
        start_time: this.startTime,
        end_time: new Date().getTime()
      }
      this.analyticSdk.analyticService.EXIT(exitData);
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
